import { jsxs, jsx, Fragment } from 'react/jsx-runtime';
import React__default, { useMemo } from 'react';
import classNames from 'classnames';
import { Chip } from '../../../Chip/Chip.es.js';
import { Icon } from '../../../Icon/Icon.es.js';
import { SelectListItemDescription } from '../SelectList.Item.Description/SelectList.Item.Description.es.js';

const SelectListItemBase = ({ item, truncate, subcomponents, selectedStyle = 'primary', isSelected })=>{
    const { label, chipIcon, chipVariant } = item ?? {};
    // Find description subcomponent
    const descriptionComponent = useMemo(()=>React__default.Children.toArray(subcomponents).find((c)=>/*#__PURE__*/ React__default.isValidElement(c) && c.type === SelectListItemDescription), [
        subcomponents
    ]);
    // Find other subcomponents
    const otherComponents = useMemo(()=>React__default.Children.toArray(subcomponents).filter((c)=>/*#__PURE__*/ React__default.isValidElement(c) && c.type !== SelectListItemDescription), [
        subcomponents
    ]);
    const itemComponents = useMemo(()=>{
        return jsxs("span", {
            className: "select-label-container",
            children: [
                jsx("span", {
                    className: classNames('select-label', {
                        truncate
                    }),
                    title: label,
                    children: chipVariant ? jsx(Chip, {
                        className: "border-none",
                        icon: chipIcon,
                        variant: chipVariant,
                        children: label
                    }) : label
                }),
                otherComponents,
                selectedStyle === 'primary' && jsx("span", {
                    className: "select-list-check-container",
                    children: isSelected && jsx(Icon, {
                        name: "CheckOutline",
                        size: 20
                    })
                })
            ]
        });
    }, [
        chipIcon,
        chipVariant,
        isSelected,
        label,
        otherComponents,
        selectedStyle,
        truncate
    ]);
    return jsxs(Fragment, {
        children: [
            itemComponents,
            descriptionComponent
        ]
    });
};

export { SelectListItemBase };
//# sourceMappingURL=SelectList.Item.Base.es.js.map
